(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chuchi-lazy-chat"] && !Shopify.designMode) return;
  try {
    (() => {
    const button = document.getElementById('chuchi-chat-launcher');
    if (!button) return;
    button.addEventListener('click', () => {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = button.dataset.loading;
      let timer;
      const fail = () => {
        observer.disconnect();
        clearTimeout(timer);
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = button.dataset.error;
        const failed = document.querySelector('script[data-chuchi-chat]');
        if (failed) failed.remove();
      };
      const ready = () => {
        if (!document.querySelector('#flyweight-chat iframe')) return;
        observer.disconnect();
        clearTimeout(timer);
        setTimeout(() => {
          window.dispatchEvent(new Event('flyweightchatopen'));
          button.hidden = true;
        }, 250);
      };
      const observer = new MutationObserver(ready);
      observer.observe(document.body, { childList: true, subtree: true });
      timer = setTimeout(fail, 20000);
      if (!document.getElementById('flyweight-chat-search')) {
        const anchor = document.createElement('div');
        anchor.id = 'flyweight-chat-search';
        anchor.setAttribute('data-flyweight-chat', '');
        anchor.dataset.search = 'true';
        document.body.appendChild(anchor);
      }
      if (!Array.from(document.scripts).some(script => script.src === button.dataset.src)) {
        const script = document.createElement('script');
        script.src = button.dataset.src;
        script.async = true;
        script.dataset.chuchiChat = 'true';
        script.onerror = fail;
        document.head.appendChild(script);
      }
      ready();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["chuchi-mhd"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('chuchi-mhd')) {
  customElements.define('chuchi-mhd', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const button = this.querySelector('button');
      const info = this.querySelector('.chuchi-mhd__info');
      if (!button || !info) return;
      let pinned = false;
      const show = (visible) => {
        info.hidden = !visible;
        button.setAttribute('aria-expanded', String(visible));
      };
      const close = () => { pinned = false; show(false); };
      this.addEventListener('pointerover', (event) => {
        if (event.pointerType === 'mouse' && button.contains(event.target)) show(true);
      }, options);
      this.addEventListener('pointerleave', () => { if (!pinned) show(false); }, options);
      button.addEventListener('focus', () => show(true), options);
      button.addEventListener('click', () => { pinned = !pinned; show(pinned); }, options);
      this.addEventListener('keydown', (event) => { if (event.key === 'Escape') { event.stopPropagation(); close(); } }, options);
      this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) close(); }, options);
      document.addEventListener('pointerdown', (event) => { if (!this.contains(event.target)) close(); }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
